// Third Party Imports
import React from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import PropTypes from 'prop-types';
import {get, isEmpty} from 'lodash';

// Relative Imports
import appActions from '../../actions/actions';
import bankingLocationActions from '../../actions/bankingLocation';
import BankingLocation from './BankingLocation';
import confirmBrandActions from '../../actions/confirmBrand';

function mapStateToProps(state) {
    return {
        publicUuid: get(state, 'app.publicUuid', '-1'),
        translations: state.app.translations,
        userType: get(state, 'app.userType', 'IPM'),

        enableContinueButton: get(state, 'bankingLocation.enableContinueButton', false),
        enableBackButton: get(state, 'bankingLocation.enableBackButton', true),
        serviceError: get(state, 'bankingLocation.serviceError', ''),

        currencyList: get(state, 'bankingLocation.currencyList', []),
        currency: get(state, 'bankingLocation.currency', ''),
        currencyError: get(state, 'bankingLocation.currencyError', ''),

        bankingCountryList: get(state, 'bankingLocation.bankingCountryList', []),
        bankingCountryCode: get(state, 'bankingLocation.bankingCountryCode', ''),
        bankingCountryCodeError: get(state, 'bankingLocation.bankingCountryCodeError', ''),

        primarySite: get(state, 'bankingLocation.primarySite', {}),
        primarySiteMap: get(state, 'bankingLocation.primarySiteMap', {}),
        siteName: get(state, 'system.siteName', ''),
        bankingCountryInfo: get(state, 'bankingLocation.bankingCountryInfo', {}),
        dyff: get(state,'app.dyff', {}),
    };
}

function mapDispatchToProps(dispatch) {
    return {
        appActions: bindActionCreators(appActions, dispatch),
        confirmBrandActions: bindActionCreators(confirmBrandActions, dispatch),
        bankingLocationActions: bindActionCreators(bankingLocationActions, dispatch),
    };
}

@connect(mapStateToProps, mapDispatchToProps)
class BankingLocationContainer extends React.Component {
    constructor(props) {
        super(props);
        this.handleBankingCountryChange = this.handleBankingCountryChange.bind(this);
        this.handleCurrencyChange = this.handleCurrencyChange.bind(this);
        this.handleFormSubmit = this.handleFormSubmit.bind(this);
        this.handleAlertDismiss = this.handleAlertDismiss.bind(this);
        this.showOnFieldBlur = this.showOnFieldBlur.bind(this);
        this.triggerEdapPageViewAction = this.triggerEdapPageViewAction.bind(this);
        this.handleBackButtonClick = this.handleBackButtonClick.bind(this);
    }

    componentWillMount() {
        if (isEmpty(this.props.primarySiteMap)) {
            this.props.appActions.enableLoadOverLay(true);
            this.props.bankingLocationActions.getSupportedSites();
        }
    }

    triggerEdapPageViewAction() {
        this.props.appActions.triggerEdapPageView(this.props.publicUuid, 'Banking Location Page');
    }

    handleFormSubmit(event) {
        event.preventDefault();
        this.props.appActions.triggerEdapEvent('generic.click', {
            eventcategory: 'Continue',
            eventaction: 'Banking Location Page submit'
        }, {});

        this.props.confirmBrandActions.confirmBrand(this.props.primarySite);
        this.props.appActions.changeAppState('CONFIRM_BRAND');
    }

    handleCurrencyChange(event) {
        event.preventDefault();
        this.props.appActions.triggerEdapEvent('generic.event', {
            eventcategory: event.target.name,
            eventaction: 'Currency selected',
            highfrequency: 'true'
        }, {});
        this.setFieldsError(event.target.id);
        this.props.bankingLocationActions.handleFieldValueChange(event.target.id, event.target.value);
        this.props.bankingLocationActions.toggleContinueButton();
    }

    handleBankingCountryChange(event) {
        event.preventDefault();
        this.props.appActions.triggerEdapEvent('generic.event', {
            eventcategory: event.target.name,
            eventaction: 'Banking location selected',
            highfrequency: 'true'
        }, {});
        this.setFieldsError(event.target.id);
        this.props.bankingLocationActions.handleFieldValueChange(event.target.id, event.target.value);
        this.props.bankingLocationActions.toggleContinueButton();
    }

    showOnFieldBlur(event) {
        event.preventDefault();
        if (!event.target.value.trim()) {
            this.setFieldsError(event.target.id);
            this.props.bankingLocationActions.setFieldError(event.target.id, 'ipmob.input.field.required');
        }
    }

    handleAlertDismiss() {
        this.props.bankingLocationActions.dismissAlertBox();
    }


    setFieldsError(errorField) {
        const fields = [
            'bankingCountry',
            'currencySelection',
        ];

        for (const fieldVal of fields) {
            if (fieldVal === errorField) {
                this.props.bankingLocationActions.setFieldError(fieldVal, '');
                break;
            }

            if ((fieldVal === 'bankingCountry' && !this.props.bankingCountryCode)
                || (fieldVal === 'currencySelection' && !this.props.currency)
            ) {
                this.props.bankingLocationActions.setFieldError(fieldVal, 'ipmob.input.field.required');
            }
        }
    }

    handleBackButtonClick(event) {
        event.preventDefault();
        this.props.appActions.triggerEdapEvent('generic.click', {
            eventcategory: 'Back'
        });

        if (this.props.userType === 'PPM') {
            this.props.appActions.changeAppState('MULTIPLE_ACCOUNTS');
            return;
        }
        // For IPM Users clear session and redirect back to intro
        window.location = '/p/onboard'
    }

    render() {
        return (<div>
            <BankingLocation
                translations={this.props.translations}

                bankingCountryList={this.props.bankingCountryList}
                bankingCountryCode={this.props.bankingCountryCode}
                handleBankingCountryChange={this.handleBankingCountryChange}
                bankingCountryCodeError={this.props.bankingCountryCodeError}
                handleBankingCountryOnBlur={this.showOnFieldBlur}

                currencyList={this.props.currencyList}
                currency={this.props.currency}
                handleCurrencyChange={this.handleCurrencyChange}
                currencyError={this.props.currencyError}
                handleCurrencyOnBlur={this.showOnFieldBlur}

                serviceError={this.props.serviceError}
                handleAlertDismiss={this.handleAlertDismiss}
                enableContinueButton={this.props.enableContinueButton}
                enableBackButton={this.props.enableBackButton}
                handleFormSubmit={this.handleFormSubmit}
                triggerEdapPageViewAction={this.triggerEdapPageViewAction}
                handleBackButtonClick={this.handleBackButtonClick}
            />
        </div>);
    }
}

BankingLocationContainer.propTypes = {
    translations: PropTypes.any, // eslint-disable-line react/forbid-prop-types
    publicUuid: PropTypes.string,
    bankingCountryCode: PropTypes.string,
    bankingCountryList: PropTypes.array, // eslint-disable-line react/forbid-prop-types
    enableContinueButton: PropTypes.bool,
    serviceError: PropTypes.string,
    bankingCountryCodeError: PropTypes.string,
    companyName: PropTypes.string,
    currency: PropTypes.string,
    currencyError: PropTypes.string,
    siteName: PropTypes.string,
    userType: PropTypes.string,
};

BankingLocationContainer.defaultProps = {
    publicUuid: '-1',
    bankingCountryCode: '',
    currencyList: [],
    bankingCountryList: [],
    enableContinueButton: false,
    serviceError: '',
    currency: '',
    currencyError: '',
    companyName: '',
    enableBackButton: true,
    siteName: '',
    userType: 'IPM'
};

export default BankingLocationContainer;
